import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Linkedin, ExternalLink } from 'lucide-react';
interface ResumeHeaderProps {
  name: string;
  title: string;
  tagline: string;
  location: string;
  linkedin: string;
  headshotUrl: string;
}
export function ResumeHeader({
  name,
  title,
  tagline,
  location,
  linkedin,
  headshotUrl
}: ResumeHeaderProps) {
  return <header className="flex flex-col-reverse md:flex-row justify-between items-start md:items-end gap-8 mb-16 print:mb-8" data-id="element-49">
      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.6
    }} className="flex-1" data-id="element-50">
        <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-slate-900 mb-4 print:text-black" data-id="element-51">
          {name}
        </h1>
        <p className="text-xl md:text-2xl text-slate-600 font-medium mb-4 max-w-2xl print:text-black" data-id="element-52">
          {title}
        </p>
        <p className="text-lg text-slate-700 mb-6 max-w-2xl leading-relaxed print:text-black" data-id="element-53">
          {tagline}
        </p>

        <div className="flex flex-wrap gap-6 text-sm font-medium text-slate-500 print:text-black" data-id="element-54">
          <div className="flex items-center gap-2" data-id="element-55">
            <MapPin className="w-4 h-4 text-blue-600 print:text-black" data-id="element-56" />
            {location}
          </div>
          <a href={`https://${linkedin}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-blue-700 transition-colors print:text-black print:no-underline" data-id="element-57">
            <Linkedin className="w-4 h-4 text-blue-600 print:text-black" data-id="element-58" />
            {linkedin}
            <ExternalLink className="w-3 h-3 opacity-50 print:hidden" data-id="element-59" />
          </a>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="relative flex-shrink-0" data-id="element-60">
        <div className="w-32 h-32 md:w-48 md:h-48 overflow-hidden rounded-lg grayscale hover:grayscale-0 transition-all duration-500 ring-1 ring-slate-200 print:grayscale-0 print:ring-0" data-id="element-61">
          <img src={headshotUrl} alt={name} className="w-full h-full object-cover" data-id="element-62" />
        </div>
        {/* Decorative element - stays visible after animation */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="absolute -z-10 top-4 -right-4 w-full h-full border-2 border-blue-600 rounded-lg hidden md:block print:hidden" data-id="element-63" />
      </motion.div>
    </header>;
}